exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#contact{background-color:#333;color:#fff;display:flex;flex-direction:column;text-align:center;padding:40px 0}#contact h2{font-size:3em;margin:0;margin-bottom:20px}#contact p{font-size:1.2em;line-height:1.2;max-width:240px;margin:0 auto}#contact .app-front-email{margin-top:30px}#contact .app-front-email .button{margin:0 5px}#contact .app-front-email .button .material-icons{margin-right:8px}@media (max-width:512px){#contact .app-front-email .button{margin:10px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-271b67d2","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/Home/PanelContact.vue
// module id = 61
// module chunks = 0